import React from 'react'

const Spinner = ({width="50px"}) => {
  return (
    <img src="https://phicode.io/assets/logo/phiode%20logo.png" width={width} style={{filter:"invert(50%)"}} alt="phi" id="loading" />
  )
}

export default Spinner
